// Bendri kainos/datos formatuotojai (žr. 40 punktų sąrašo site #16) — anksčiau
// `.toFixed(2)`/`Math.round`/`toLocaleDateString('lt-LT')` buvo pakartota
// nepriklausomai keliuose failuose (Cart/Checkout/FurnitureItem/Dashboard ir
// t.t.), rizikuojant centų/formato neatitikimais tarp puslapių.

// `showCents`: 'auto' (numatytoji) — rodo centus TIK jei jie nenulinis
// (99 € vs 99.50 €); true/false priverstinai įjungia/išjungia.
export function formatPrice(value, { showCents = 'auto' } = {}) {
  const num = Number(value) || 0;
  if (showCents === true) return `${num.toFixed(2)} €`;
  if (showCents === false) return `${Math.round(num)} €`;
  return Number.isInteger(num) ? `${num} €` : `${num.toFixed(2)} €`;
}

export function formatDate(value) {
  if (!value) return '';
  try { return new Date(value).toLocaleDateString('lt-LT'); } catch { return ''; }
}

export function formatDateTime(value) {
  if (!value) return '';
  try { return new Date(value).toLocaleString('lt-LT'); } catch { return ''; }
}
